<template>
  <div class="overlay">
    <!-- Agent Icon -->
    <img :alt="app.displayName" class="app-icon" :src="app.avatarUri" v-if="app.avatarUri" />
    <img
      :alt="app.displayName"
      class="app-icon"
      src="https://console.dialogflow.com/api-client/assets/img/logo-short.png"
      v-else
    />

    <!-- Agent Title -->

    <!-- Agent Description -->
    <p class="app-description">{{ app.description }}</p>

    <button v-on:click="sendHi" class="call-to-action">
      <svg
        v-if="clickedSend"
        key="spinner"
        class="btn-icon spinner"
        width="24"
        height="24"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          stroke="white"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        />
      </svg>
      <i v-else class="material-icons btn-icon" aria-hidden="true">mood</i>
      <span v-if="!clickedSend">
        {{
        (config.i18n[sel_lang] && config.i18n[sel_lang].callToAction) ||
        config.i18n[config.app.fallback_lang].callToAction
        }}
      </span>
    </button>
  </div>
</template>

<style lang="sass" scoped>
.overlay
    text-align: center
    display: flex
    flex-direction: column
    align-items: center
    padding: 25px 0
    box-sizing: border-box
    height: 100%
    max-width: 400px
    margin: auto

.app-icon
    max-width: 120px
    border-radius: 16px
    object-fit: cover

.app-title
    font-weight: 500
    font-size: 24px
    margin-top: 30px
    color: #202124
    line-height: 20px
    white-space: pre-wrap

.btn-icon
    vertical-align: middle

.app-description
    font-size: 16px
    color: #5F6368

.call-to-action
    background-color: #33426c
    color: white
    box-shadow: 0 10px 15px -5px rgba(0,0,0,.4)
    display: inline-block
    padding: 12px
    border: none
    font: inherit
    border-radius: 100px
    cursor: pointer
    margin-top: auto
    font-weight: 500
    font-size: 1.2em
    margin-right: 2px
    transition: transform .2s cubic-bezier(.25,.46,.45,.94)
    &:active
        transform: scale(.9)

.spinner
    animation: rotator 1.4s linear infinite

.path
    stroke-dasharray: 187
    stroke-dashoffset: 0
    transform-origin: center
    animation: dash 1.4s ease-in-out infinite

@keyframes rotator
    0%
        transform: rotate(0deg)
    100%
        transform: rotate(270deg)

@keyframes dash
    0%
        stroke-dashoffset: 187
    50%
        stroke-dashoffset: 46.75
        transform: rotate(135deg)
    100%
        stroke-dashoffset: 187
        transform: rotate(450deg)
</style>

<script>
const langs = require("langs");

export default {
  name: "welcome",
  props: ["app"],
  data() {
    return {
      sel_lang: this.app.defaultLanguageCode,
      clickedSend: false
    };
  },
  methods: {
    sendHi() {
      if (!this.clickedSend) {
        this.$emit("submit", "Começar");
        this.clickedSend = true;
      }
    }
  },
  watch: {
    /* Select translations */
    sel_lang(lang) {
      if (this.history()) localStorage.setItem("lang", lang);
      else {
        this.config.app.fallback_lang = lang;
      }
    }
  },
  filters: {
    /* This filter turns language code to the local language name using the langs dependency (example "en" -> "English") */
    toLang(code) {
      return langs.where("1", code).local;
    }
  }
};
</script>
